module.exports = __webpack_public_path__ + "img/1_2-edificabile.3f927f8b.png";